import { render, staticRenderFns } from "./TaxPph22View.vue?vue&type=template&id=f85443ea"
import script from "./TaxPph22View.vue?vue&type=script&lang=js"
export * from "./TaxPph22View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports